import { useQuery } from '@tanstack/react-query';
import { CompanyService } from './CompanyService';

export function useGetSupplierCompanyData({
    search,
    registrationCode,
}: {
    search?: string;
    registrationCode?: string;
}) {
    const { data, isLoading, isFetching, error } = useQuery(
        ['SupplierCompanyPublicData', search, registrationCode],
        async () => {
            const service = new CompanyService();

            const company = await service.getSupplierCompanyInformation(search!, registrationCode!);

            return company;
        },
        {
            enabled: !!search,
            staleTime: Infinity,
            cacheTime: Infinity,
        }
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        error,
    };
}
